var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Icons",
    clipPath: "url(#clip0_4311_16070)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8323 1.15242L11.1252 0.445312L10.418 1.15242L2.26624 9.30422L2.07846 9.492L2.00859 9.74821L0.896979 13.8241L0.436523 15.5124L2.12486 15.052L6.20076 13.9404L6.45697 13.8705L6.64475 13.6827L14.7965 5.53092L15.5037 4.82382L14.7965 4.11671L11.8323 1.15242ZM3.28696 12.662L3.86824 10.5306L9.97958 4.41931L11.5297 5.96939L5.41832 12.0807L3.28696 12.662Z",
    fill: "#09253C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4311_16070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6fcc1a3a2a43561a7280d01ac0ce8e10.svg";
export { ForwardRef as ReactComponent };